import Legend from "@arcgis/core/widgets/Legend";
export function initLegend(settings) {
    let legend = new Legend({
        view: settings.mapView,
        layerInfos: [
            {
                layer: settings.layer,
                title: settings.title
            }
        ]
    });
    settings.mapView.ui.add(legend, settings.position);
    return legend;
}
